<template>
  <div class="px-4 sm:px-6 lg:px-8 bg-gray-800 min-h-screen  pt-10">
    <!-- Nagłówek -->
    <div class="flex flex-col items-center justify-center mb-8">
      <input
        v-model="searchTerm"
        type="text"
        placeholder="Szukaj po tytule, ID lub typie..."
        class="w-full max-w-xl text-lg rounded-full border border-gray-700 py-3 px-6 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-800 text-gray-100 placeholder-gray-400 mb-4"
      />
    </div>
    <div class="flex flex-col sm:flex-row sm:items-center mb-4 justify-between">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-white">
          Videos ({{ filteredVideos.length }})
        </h1>
        <p class="mt-2 text-sm text-gray-400">
          Lista filmów z bazy danych.
        </p>
      </div>
      <div class="flex justify-end w-full sm:w-auto mt-4 sm:mt-0">
        <label class="flex items-center cursor-pointer select-none">
          <span class="mr-3 text-gray-200 text-lg font-medium">YES only</span>
          <span class="relative">
            <input type="checkbox" v-model="filterResponseYes" class="sr-only peer" />
            <span class="w-11 h-6 bg-gray-400 rounded-full shadow-inner block peer-checked:bg-blue-600 transition-colors"></span>
            <span class="dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform peer-checked:translate-x-5"></span>
          </span>
        </label>
      </div>
    </div>

    <!-- Tabela z danymi -->
    <div class="mt-8 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-gray-700">
              <thead class="bg-gray-700">
                <tr>
                  <!-- Video ID -->
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-200">
                    <a href="#" @click.prevent="sortBy('video_id')" class="group inline-flex">
                      Video ID
                      <span class="ml-2 flex-none">
                        <ChevronUpIcon v-if="!sortState.video_id.ascending" class="h-5 w-5" aria-hidden="true" />
                        <ChevronDownIcon v-if="sortState.video_id.ascending" class="h-5 w-5" aria-hidden="true" />
                      </span>
                    </a>
                  </th>
                  <!-- Title z przycinaniem -->
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-200">
                    <a href="#" @click.prevent="sortBy('title')" class="group inline-flex">
                      Title
                      <span class="ml-2 flex-none">
                        <ChevronUpIcon v-if="!sortState.title.ascending" class="h-5 w-5" aria-hidden="true" />
                        <ChevronDownIcon v-if="sortState.title.ascending" class="h-5 w-5" aria-hidden="true" />
                      </span>
                    </a>
                  </th>
                  <!-- Published At -->
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200">
                    <a href="#" @click.prevent="sortBy('published_at')" class="group inline-flex">
                      Published At
                      <span class="ml-2 flex-none">
                        <ChevronUpIcon v-if="!sortState.published_at.ascending" class="h-5 w-5" aria-hidden="true" />
                        <ChevronDownIcon v-if="sortState.published_at.ascending" class="h-5 w-5" aria-hidden="true" />
                      </span>
                    </a>
                  </th>
                  <!-- Duration -->
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200">
                    <a href="#" @click.prevent="sortBy('duration')" class="group inline-flex">
                      Duration
                      <span class="ml-2 flex-none">
                        <ChevronUpIcon v-if="!sortState.duration.ascending" class="h-5 w-5" aria-hidden="true" />
                        <ChevronDownIcon v-if="sortState.duration.ascending" class="h-5 w-5" aria-hidden="true" />
                      </span>
                    </a>
                  </th>
                  <!-- Type -->
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200">
                    <a href="#" @click.prevent="sortBy('type')" class="group inline-flex">
                      Type
                      <span class="ml-2 flex-none">
                        <ChevronUpIcon v-if="!sortState.type.ascending" class="h-5 w-5" aria-hidden="true" />
                        <ChevronDownIcon v-if="sortState.type.ascending" class="h-5 w-5" aria-hidden="true" />
                      </span>
                    </a>
                  </th>
                  <!-- Flag -->
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200">
                    Flag
                  </th>
                  <!-- Response -->
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200">
                    Response
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-700 bg-gray-800">
                <tr
                  v-for="video in filteredVideos"
                  :key="video.video_id"
                  @click="selectRecord(video)"
                  :class="[
                    'cursor-pointer transition-colors duration-200 group',
                    selectedRecord?.video_id === video.video_id 
                      ? 'bg-blue-600 bg-opacity-20 border-l-4 border-blue-500' 
                      : 'hover:bg-gray-600'
                  ]"
                >
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-left text-sm font-medium text-white">
                    {{ video.video_id }}
                  </td>
                  <td class="whitespace-normal overflow-hidden text-ellipsis clamped-title py-4 pl-4 pr-3 text-left text-sm font-medium text-white">
                    {{ video.title }}
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-left text-sm text-gray-400">
                    {{ formatPublishedAt(video.published_at) }}
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-left text-sm text-gray-400">
                    {{ formatDuration(video.duration) }}
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-left text-sm text-gray-400">
                    {{ video.type }}
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-left text-sm text-gray-400">
                    {{ video.flag }}
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-left text-sm text-gray-400">
                    {{ video.response ? "YES" : "" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal z danymi rekordu -->
    <div v-if="selectedRecord" class="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div class="bg-gray-800 w-full h-full flex flex-col rounded-lg shadow-2xl transform transition-all duration-300 ease-out">
        <!-- Header -->
        <div class="flex justify-between items-center p-6 border-b border-gray-700 bg-gray-800 rounded-t-lg">
          <div class="flex items-center space-x-4">
            <div class="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <h2 class="text-xl font-bold text-white">Szczegóły filmu</h2>
              <p class="text-gray-400 text-sm">{{ selectedRecord.video_id }}</p>
            </div>
          </div>
          <button 
            @click="selectedRecord = null" 
            class="text-gray-400 hover:text-blue-500 transition-colors duration-200 p-2 rounded-full hover:bg-gray-700 bg-gray-800 "
          >
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Content -->
        <div class="p-6 overflow-y-auto flex-1">
          <!-- Basic Information Section -->
          <div class="mb-8">
            <div class="flex items-center mb-4">
              <div class="w-1 h-6 bg-blue-500 rounded-full mr-3"></div>
              <h3 class="text-lg font-semibold text-white">Podstawowe informacje</h3>
            </div>
            
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <!-- Video ID -->
              <div class="space-y-2">
                <label class="block text-sm font-medium text-gray-300">Video ID</label>
                <div class="relative">
                  <input
                    type="text"
                    v-model="selectedRecord.video_id"
                    class="w-full rounded-lg border border-gray-600 p-3 bg-gray-700 text-gray-200 font-mono text-sm"
                    readonly
                  />
                  <div class="absolute inset-y-0 right-0 flex items-center pr-3">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                </div>
              </div>

              <!-- Title -->
              <div class="space-y-2">
                <label class="block text-sm font-medium text-gray-300">Tytuł</label>
                <input
                  type="text"
                  v-model="selectedRecord.title"
                  class="w-full rounded-lg border border-gray-600 p-3 bg-gray-700 text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="Wprowadź tytuł filmu"
                />
              </div>

              <!-- Published At -->
              <div class="space-y-2">
                <label class="block text-sm font-medium text-gray-300">Data publikacji</label>
                <div class="relative">
                  <input
                    type="datetime-local"
                    v-model="selectedRecord.published_at"
                    class="w-full rounded-lg border border-gray-600 p-3 bg-gray-700 text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  />
                  <button
                    @click="openDatePicker"
                    class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-blue-400 transition-colors rounded-full  p-3 bg-gray-700 hover:bg-gray-700  my-2 mr-1"
                    type="button"
                  >
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </button>
                </div>
              </div>

              <!-- Duration -->
              <div class="space-y-2">
                <label class="block text-sm font-medium text-gray-300">Czas trwania</label>
                <div class="relative">
                  <input
                    type="text"
                    v-model="selectedRecord.duration"
                    class="w-full rounded-lg border border-gray-600 p-3 bg-gray-700 text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                    placeholder="PT4M13S"
                  />
                  <div class="absolute inset-y-0 right-0 flex items-center pr-3">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>
              </div>

              <!-- Type -->
              <div class="space-y-2">
                <label class="block text-sm font-medium text-gray-300">Typ</label>
                <select
                  v-model="selectedRecord.type"
                  class="w-full rounded-lg border border-gray-600 p-3 bg-gray-700 text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                >
                  <option value="">Wybierz typ</option>
                  <option value="video">Video</option>
                  <option value="short">Short</option>
                  <option value="live">Live</option>
                </select>
              </div>

              <!-- Flag -->
              <div class="space-y-2">
                <label class="block text-sm font-medium text-gray-300">Flaga</label>
                <div class="flex items-center">
                  <label class="flex items-center cursor-pointer select-none">
                    <span class="relative">
                      <input 
                        type="checkbox" 
                        v-model="selectedRecord.flag" 
                        class="sr-only peer"
                      />
                      <span class="w-11 h-6 bg-gray-400 rounded-full shadow-inner block peer-checked:bg-blue-600 transition-colors"></span>
                      <span class="dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform peer-checked:translate-x-5"></span>
                    </span>
                    <span class="ml-3 text-sm text-gray-300">{{ selectedRecord.flag ? 'Tak' : 'Nie' }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!-- Captions Section -->
          <div class="mb-8" v-if="selectedRecord.captions">
            <div class="flex items-center mb-4">
              <div class="w-1 h-6 bg-green-500 rounded-full mr-3"></div>
              <h3 class="text-lg font-semibold text-white">Napisy</h3>
            </div>
            <div class="space-y-2">
              <label class="block text-sm font-medium text-gray-300">Tekst napisów</label>
              <textarea
                v-model="selectedRecord.captions"
                rows="4"
                class="w-full rounded-lg border border-gray-600 p-3 bg-gray-700 text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                placeholder="Wprowadź tekst napisów..."
              ></textarea>
            </div>
          </div>

          <!-- Response Section -->
          <div class="mb-8">
            <div class="flex items-center mb-4">
              <div class="w-1 h-6 bg-purple-500 rounded-full mr-3"></div>
              <h3 class="text-lg font-semibold text-white">Odpowiedź JSON</h3>
            </div>
            <div class="space-y-2">
              <label class="block text-sm font-medium text-gray-300">Dane JSON</label>
              <textarea
                v-model="selectedRecord.response"
                rows="6"
                class="w-full rounded-lg border border-gray-600 p-3 bg-gray-700 text-gray-200 font-mono text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                placeholder='{"title": "Przykład", "opis": "Opis filmu..."}'
              ></textarea>
            </div>
          </div>

          <!-- JSON Editor Section -->
          <div v-if="parsedResponse" class="mb-8">
            <div class="flex items-center justify-between mb-4">
              <div class="flex items-center">
                <div class="w-1 h-6 bg-yellow-500 rounded-full mr-3"></div>
                <h3 class="text-lg font-semibold text-white">Edytor JSON</h3>
              </div>
              <div class="flex items-center space-x-2">
                <span class="text-sm text-gray-400">{{ parsedResponse.length }} elementów</span>
                <button
                  @click="parsedResponse.push({})"
                  class="px-3 py-1 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition-colors flex items-center space-x-1"
                >
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                  </svg>
                  <span>Dodaj</span>
                </button>
              </div>
            </div>

            <div class="space-y-6">
              <div
                v-for="(item, index) in parsedResponse"
                :key="index"
                class="bg-gray-700 rounded-lg p-6 border border-gray-600"
              >
                <!-- Item Header -->
                <div class="flex items-center justify-between mb-4">
                  <h4 class="text-md font-medium text-white">Element {{ index + 1 }}</h4>
                  <button
                    @click="parsedResponse.splice(index, 1); updateResponse()"
                    class="text-red-400 hover:text-red-300 transition-colors p-1 rounded"
                  >
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>

                <!-- Content Grid -->
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  <!-- Left Column: Name, Address, Name YT, Tags -->
                  <div class="space-y-4">
                    <div>
                      <label class="block text-sm font-medium text-gray-300 mb-1">Nazwa</label>
                      <input
                        type="text"
                        v-model="item.title"
                        class="w-full rounded-md border border-gray-600 p-2 bg-gray-800 text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        @input="updateResponse"
                        placeholder="Nazwa miejsca"
                      />
                    </div>

                    <!-- Address Info -->
                    <div class="bg-gray-800 rounded-md p-4">
                      <h5 class="text-sm font-medium text-gray-300 mb-3">Adres</h5>
                      <div class="grid grid-cols-1 gap-3">
                        <div>
                          <label class="block text-xs text-gray-400 mb-1">Ulica</label>
                          <input
                            type="text"
                            v-model="item.adres.street"
                            class="w-full rounded border border-gray-600 p-2 bg-gray-700 text-gray-200 text-sm focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                            @input="updateResponse"
                            placeholder="Nazwa ulicy"
                          />
                        </div>
                        <div class="grid grid-cols-2 gap-3">
                          <div>
                            <label class="block text-xs text-gray-400 mb-1">Kod pocztowy</label>
                            <input
                              type="text"
                              v-model="item.adres.postcode"
                              class="w-full rounded border border-gray-600 p-2 bg-gray-700 text-gray-200 text-sm focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                              @input="updateResponse"
                              placeholder="00-000"
                            />
                          </div>
                          <div>
                            <label class="block text-xs text-gray-400 mb-1">Miasto</label>
                            <input
                              type="text"
                              v-model="item.adres.city"
                              class="w-full rounded border border-gray-600 p-2 bg-gray-700 text-gray-200 text-sm focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                              @input="updateResponse"
                              placeholder="Nazwa miasta"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-300 mb-1">Nazwa YT</label>
                      <input
                        type="text"
                        v-model="item.nazwaYT"
                        class="w-full rounded-md border border-gray-600 p-2 bg-gray-800 text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        @input="updateResponse"
                        placeholder="Nazwa na YouTube"
                      />
                    </div>

                    <!-- Tags -->
                    <div>
                      <label class="block text-sm font-medium text-gray-300 mb-1">Tagi</label>
                      <div class="space-y-2">
                        <div v-for="(typeItem, typeIndex) in item.type" :key="typeIndex" class="flex gap-2">
                          <input
                            type="text"
                            v-model="item.type[typeIndex]"
                            class="flex-1 rounded-md border border-gray-600 p-2 bg-gray-800 text-gray-200 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                            @input="updateResponse"
                            placeholder="Tag miejsca"
                          />
                          <button
                            @click="item.type.splice(typeIndex, 1); updateResponse()"
                            class="px-2 py-1 text-red-400 hover:text-red-300 transition-colors rounded-full bg-gray-700 hover:bg-gray-700"
                          >
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                          </button>
                        </div>
                        <button
                          @click="item.type.push(''); updateResponse()"
                          class=" px-3 py-2 border border-gray-600 rounded-md text-gray-200 hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 text-sm"
                        >
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                          </svg>
                          Dodaj tag
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Right Column: Short Description and Description -->
                  <div class="space-y-4">
                    <div>
                      <label class="block text-sm font-medium text-gray-300 mb-1">Krótki opis</label>
                      <textarea
                        v-model="item.shortDesc"
                        rows="3"
                        class="w-full rounded-md border border-gray-600 p-2 bg-gray-800 text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                        @input="updateResponse"
                        placeholder="Krótki opis miejsca"
                      ></textarea>
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-300 mb-1">Opis</label>
                      <textarea
                        v-model="item.opis"
                        rows="8"
                        class="w-full rounded-md border border-gray-600 p-2 bg-gray-800 text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                        @input="updateResponse"
                        placeholder="Szczegółowy opis miejsca"
                      ></textarea>
                    </div>
                  </div>
                </div>

                <!-- General Video Information Section -->
                <div class="mt-6 pt-6 border-t border-gray-600">
                  <div class="flex items-center mb-4">
                    <div class="w-1 h-6 bg-indigo-500 rounded-full mr-3"></div>
                    <h5 class="text-md font-medium text-white">Ogólne informacje o filmie</h5>
                  </div>
                  
                  <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    <div>
                      <label class="block text-sm font-medium text-gray-300 mb-1">isMuala</label>
                      <div class="flex items-center">
                        <label class="flex items-center cursor-pointer select-none">
                          <span class="relative">
                            <input 
                              type="checkbox" 
                              v-model="item.isMuala" 
                              class="sr-only peer"
                              @change="updateResponse"
                            />
                            <span class="w-11 h-6 bg-gray-400 rounded-full shadow-inner block peer-checked:bg-blue-600 transition-colors"></span>
                            <span class="dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform peer-checked:translate-x-5"></span>
                          </span>
                          <span class="ml-3 text-sm text-gray-300">{{ item.isMuala ? 'YES' : 'NO' }}</span>
                        </label>
                      </div>
                    </div>
                    
                    <div>
                      <label class="block text-sm font-medium text-gray-300 mb-1">Autor</label>
                      <input
                        type="text"
                        v-model="item.author"
                        class="w-full rounded-md border border-gray-600 p-2 bg-gray-800 text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        @input="updateResponse"
                        placeholder="Nazwa autora"
                      />
                    </div>
                    
                    <div>
                      <label class="block text-sm font-medium text-gray-300 mb-1">Timestamp</label>
                      <input
                        type="text"
                        v-model="item.timestamp"
                        class="w-full rounded-md border border-gray-600 p-2 bg-gray-800 text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        @input="updateResponse"
                        placeholder="00:00"
                      />
                    </div>
                    
                    <div>
                      <label class="block text-sm font-medium text-gray-300 mb-1">Video ID</label>
                      <input
                        type="text"
                        v-model="item.videoId"
                        class="w-full rounded-md border border-gray-600 p-2 bg-gray-800 text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        @input="updateResponse"
                        placeholder="YouTube video ID"
                      />
                    </div>
                    
                    <div class="lg:col-span-2">
                      <label class="block text-sm font-medium text-gray-300 mb-1">URL Google Search</label>
                      <div class="flex gap-2">
                        <input
                          type="url"
                          v-model="item.urlGoogleSearch"
                          class="flex-1 rounded-md border border-gray-600 p-2 bg-gray-800 text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                          @input="updateResponse"
                          placeholder="https://google.com/search..."
                        />
                        <a
                          :href="item.urlGoogleSearch"
                          target="_blank"
                          class="inline-flex items-center px-3 py-2 border border-gray-600 rounded-md text-gray-200 hover:bg-gray-700 transition-colors"
                          title="Otwórz w nowej karcie"
                        >
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- URLs Section -->
                <div v-if="item.urlOther" class="mt-4">
                  <label class="block text-sm font-medium text-gray-300 mb-1">URL Other</label>
                  <div class="flex gap-2">
                    <input
                      type="url"
                      v-model="item.urlOther"
                      class="flex-1 rounded-md border border-gray-600 p-2 bg-gray-800 text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                      @input="updateResponse"
                      placeholder="https://example.com"
                    />
                    <a
                      :href="item.urlOther"
                      target="_blank"
                      class="inline-flex items-center px-3 py-2 border border-gray-600 rounded-md text-gray-200 hover:bg-gray-700 transition-colors"
                      title="Otwórz w nowej karcie"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="flex justify-end items-center p-6 border-t border-gray-700 bg-gray-800 rounded-b-lg">
          <div class="flex space-x-3">
            <button
              @click="selectedRecord = null"
              class="px-4 py-2 border border-gray-600 rounded-lg text-gray-300 hover:bg-gray-700 transition-colors"
            >
              Anuluj
            </button>
            <button
              @click="saveRecord"
              class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2"
              title="Zapisz zmiany (Ctrl+S)"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
              <span>Zapisz zmiany</span>
              <span class="text-xs opacity-75">(Ctrl+S)</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, reactive, onUnmounted } from 'vue';
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/vue/20/solid';
import { apiFetch } from '../composables/apiClient';

const videos = ref([]);
const searchTerm = ref('');
const filterResponseYes = ref(false);
const selectedRecord = ref(null);

// Ustawiamy domyślną kolejność dla published_at (false = descending)
const sortState = reactive({
  video_id: { ascending: true },
  title: { ascending: true },
  published_at: { ascending: false },
  duration: { ascending: true },
  type: { ascending: true },
});

// Funkcja sortująca
const sortBy = (key) => {
  if (!sortState[key]) {
    console.error(`Klucz ${key} nie istnieje w sortState`);
    return;
  }
  sortState[key].ascending = !sortState[key].ascending;
  videos.value.sort((a, b) => {
    if (a[key] < b[key]) return sortState[key].ascending ? -1 : 1;
    if (a[key] > b[key]) return sortState[key].ascending ? 1 : -1;
    return 0;
  });
};

// Formatujemy datę
const formatPublishedAt = (dateStr) => {
  if (!dateStr) return '';
  return dateStr.replace('T', ' ').replace('Z', '');
};

// Formatujemy czas trwania
const formatDuration = (durationStr) => {
  if (!durationStr || !durationStr.startsWith("PT")) return durationStr;
  const withoutPT = durationStr.slice(2);
  let minutes = "0";
  let seconds = "0";
  const mIndex = withoutPT.indexOf("M");
  const sIndex = withoutPT.indexOf("S");
  if (mIndex !== -1) {
    minutes = withoutPT.substring(0, mIndex);
    if (sIndex !== -1) {
      seconds = withoutPT.substring(mIndex + 1, sIndex);
    }
  } else if (sIndex !== -1) {
    seconds = withoutPT.substring(0, sIndex);
  }
  if (seconds.length === 1) seconds = "0" + seconds;
  return `${minutes}:${seconds}`;
};

// Filtrowanie – wyszukiwanie oraz filtr Response
const filteredVideos = computed(() => {
  let result = videos.value;
  if (searchTerm.value) {
    result = result.filter(video =>
      video.title.toLowerCase().includes(searchTerm.value.toLowerCase()) ||
      video.video_id.toLowerCase().includes(searchTerm.value.toLowerCase()) ||
      video.type.toLowerCase().includes(searchTerm.value.toLowerCase())
    );
  }
  if (filterResponseYes.value) {
    result = result.filter(video => !!video.response);
  }
  return result;
});

// Parsowanie JSONa z pola response
const parsedResponse = computed(() => {
  if (selectedRecord.value && selectedRecord.value.response) {
    console.log('Response content:', selectedRecord.value.response);
    let jsonContent = selectedRecord.value.response;

    // Sprawdź czy zawiera znaczniki ```json
    const regex = /```json\s*([\s\S]*?)\s*```/;
    const match = jsonContent.match(regex);
    
    if (match && match[1]) {
      // Jeśli zawiera znaczniki, użyj zawartości między nimi
      jsonContent = match[1];
    }

    try {
      const parsed = JSON.parse(jsonContent);
      console.log('Parsed JSON:', parsed);
      return parsed;
    } catch (e) {
      console.error("Błąd parsowania JSON:", e);
      return null;
    }
  }
  return null;
});

// Po kliknięciu w wiersz ustawiamy wybrany rekord (tworzymy kopię)
const selectRecord = (record) => {
  console.log('Selected record:', record);
  selectedRecord.value = { ...record };
  
  // Konwertuj datę do formatu datetime-local
  if (selectedRecord.value.published_at) {
    const date = new Date(selectedRecord.value.published_at);
    selectedRecord.value.published_at = date.toISOString().slice(0, 16);
  }
  
  console.log('Parsed response after selection:', parsedResponse.value);
};

// Funkcja do otwierania date pickera
const openDatePicker = () => {
  const dateInput = document.querySelector('input[type="datetime-local"]');
  if (dateInput) {
    dateInput.showPicker();
  }
};

// Dodaj funkcję updateResponse do sekcji script
const updateResponse = () => {
  if (selectedRecord.value && parsedResponse.value) {
    const jsonString = JSON.stringify(parsedResponse.value, null, 2);
    // Zawsze zapisujemy z znacznikami ```json
    selectedRecord.value.response = `\`\`\`json\n${jsonString}\n\`\`\``;
  }
};

// Funkcja zapisywania zmian
const saveRecord = async () => {
  try {
    // Walidacja podstawowych pól
    if (!selectedRecord.value.title?.trim()) {
      alert('Tytuł jest wymagany');
      return;
    }
    
    // Znajdź indeks rekordu w tablicy videos
    const index = videos.value.findIndex(video => video.video_id === selectedRecord.value.video_id);
    
    if (index !== -1) {
      // Aktualizuj rekord w tablicy
      videos.value[index] = { ...selectedRecord.value };
      
      // Tutaj możesz dodać wywołanie API do zapisania zmian na serwerze
      // const response = await fetch(`http://api.157.90.25.23.sslip.io/api/videos/${selectedRecord.value.video_id}`, {
      //   method: 'PUT',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify(selectedRecord.value),
      // });
      
      // if (response.ok) {
      //   console.log('Rekord został zapisany pomyślnie');
      // } else {
      //   console.error('Błąd podczas zapisywania rekordu');
      // }
      
      console.log('Zmiany zostały zapisane lokalnie');
      
      // Pokaż komunikat o sukcesie
      const successMessage = document.createElement('div');
      successMessage.className = 'fixed top-4 right-4 bg-green-600 text-white px-6 py-3 rounded-lg shadow-lg z-50';
      successMessage.textContent = 'Zmiany zostały zapisane pomyślnie!';
      document.body.appendChild(successMessage);
      
      setTimeout(() => {
        document.body.removeChild(successMessage);
      }, 3000);
      
      selectedRecord.value = null;
    }
  } catch (error) {
    console.error('Błąd podczas zapisywania:', error);
    
    // Pokaż komunikat o błędzie
    const errorMessage = document.createElement('div');
    errorMessage.className = 'fixed top-4 right-4 bg-red-600 text-white px-6 py-3 rounded-lg shadow-lg z-50';
    errorMessage.textContent = 'Wystąpił błąd podczas zapisywania';
    document.body.appendChild(errorMessage);
    
    setTimeout(() => {
      document.body.removeChild(errorMessage);
    }, 3000);
  }
};

// Pobieramy dane z API
onMounted(async () => {
  try {
    const response = await apiFetch('/api/videos');
    if (response.ok) {
      videos.value = await response.json();
      // Domyślne sortowanie wg published_at (malejąco)
      videos.value.sort((a, b) => a.published_at < b.published_at ? 1 : -1);
    } else {
      console.error('Błąd podczas pobierania danych.');
    }
  } catch (error) {
    console.error('Błąd:', error);
  }

  // Dodaj obsługę klawisza Escape do zamykania modala
  const handleEscape = (e) => {
    if (e.key === 'Escape' && selectedRecord.value) {
      selectedRecord.value = null;
    }
  };
  
  // Dodaj obsługę klawisza Ctrl+S do zapisywania
  const handleSave = (e) => {
    if (e.ctrlKey && e.key === 's' && selectedRecord.value) {
      e.preventDefault();
      saveRecord();
    }
  };
  
  window.addEventListener('keydown', handleEscape);
  window.addEventListener('keydown', handleSave);
  
  // Cleanup listener on component unmount
  onUnmounted(() => {
    window.removeEventListener('keydown', handleEscape);
    window.removeEventListener('keydown', handleSave);
  });
});
</script>

<style scoped>
/* Klasa przycinająca tytuł do 2 wierszy */
.clamped-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Prevent body scroll when modal is open */
:global(body.modal-open) {
  overflow: hidden;
}
.dot {
  transition: transform 0.2s;
}
input[type="checkbox"].peer:checked + span + .dot {
  transform: translateX(20px);
}
</style>
